import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'accounts'
const verb = 'get'

export default class OspreyAccountsStats extends BaseAction {
    constructor() {
        const id = 'ffb92b92-82b3-40ea-a150-25e514edfa6b'
        const path = `/${resource}/stats`
        super(resource, verb, path, id)
        this.noCache = true
    }

    getStats(fields) {
        if (!fields) {
            fields = 'status'
        }
        if (Array.isArray(fields)) {
            fields = fields.join(',')
        }

        this.params = {
            fields
        }

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/accounts/accounts-stats.js